import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CustomerAccountingInfo } from '../model';
import { Table, TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { CustomerAccountingService } from '../customer-accounting.service';
import { ActivatedRoute } from '@angular/router';
import { EditorModule } from 'primeng/editor';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { CheckboxModule } from 'primeng/checkbox';
import { CustomerTabFilterPipe } from '../customer-tab-filter.pipe';

@Component({
  selector: 'app-customer-accounting-tab',
  imports: [
    FormsModule, InputTextModule, FileUploadModule, DialogModule, CommonModule, CheckboxModule,
    TableModule, ButtonModule, ToolbarModule, DatePickerModule, ConfirmDialog, TagModule,
    InputNumberModule, SelectModule, EditorModule, IconFieldModule, InputIconModule,
    CustomerTabFilterPipe
  ],
  providers: [ConfirmationService],
  templateUrl: './customer-accounting-tab.component.html',
  styleUrl: './customer-accounting-tab.component.scss'
})
export class CustomerAccountingTabComponent {

  @ViewChild('dt2') dt: Table | undefined;

  protected nowLoadingModal: boolean = false;
  protected onlyNotSent: boolean = false;
  protected isLoading: boolean = true;
  protected data: CustomerAccountingInfo[] = [];
  protected selectedItem: CustomerAccountingInfo | null = null;
  protected date: string = '';
  protected dateObj: Date = new Date();
  protected displayEmailPreview = false;
  protected emailData: any = null;

  protected testEmailModal: boolean = false;
  protected testEmail: string = 'accountingdpt@i-host.gr';
  protected testEmailDirty = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: CustomerAccountingService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.url.subscribe(url => {
      this.dateObj = new Date(parseInt(url[2]?.path ?? 0));
      this.date = `${this.dateObj.getDate()}-${this.dateObj.getMonth() + 1}-${this.dateObj.getFullYear()}`;

      this.refreshData();
    });
  }

  private refreshData() {
    this.service.get(this.dateObj).subscribe(data => {
      this.isLoading = false;
      this.data = data;
      this.nowLoadingModal = false;
    });
  }

  preview(event: Event, item: CustomerAccountingInfo) {
    event?.preventDefault();

    if (item == null || item.notifications == null || item.notifications.length === 0) {
      return;
    }

    this.selectedItem = item;

    this.service.previewNotification(item.notifications[0].id).subscribe((data) => {
      this.emailData = data;
      this.displayEmailPreview = true;
      this.testEmailDirty = false;
    });
  }

  deleteEntry(event: Event, item: CustomerAccountingInfo) {
    event?.preventDefault();

    this.confirmationService.confirm({
      message: 'This will delete the selected entry do you want to continue?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.delete(item.id).subscribe(() => {
          this.refreshData();
        });
      }
    });
  }

  filterGlobal(event: any) {
    this.dt?.filterGlobal(event.target.value, 'contains');
  }

  saveCustomContent() {
    const item = this.selectedItem;

    if (item == null || item.notifications == null || item.notifications.length === 0) {
      return;
    }

    const notification = item.notifications[0];
    this.service.updateNotificationContent({
      id: notification.id,
      body: this.emailData.body,
      cc: this.emailData.cc,
      to: this.emailData.recipient,
      subject: this.emailData.subsject
    }).subscribe(() => {
      this.testEmailDirty = false;
    });
  }

  sendEmails() {
    this.confirmationService.confirm({
      message: 'This will send actual emails do you want to continue?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.nowLoadingModal = true;
        this.selectedItem = null;
        this.service.sendEmails(this.dateObj).subscribe(() => {
          this.refreshData();
        });
      }
    });
  }

  sendTestEmail() {
    if (this.selectedItem == null || this.selectedItem.notifications == null || this.selectedItem.notifications.length === 0) {
      return;
    }

    this.service.sendTestEmail(this.selectedItem.notifications[0].id, this.testEmail).subscribe(() => {
      this.testEmailModal = false;
    });
  }

  sendEmail() {
    this.confirmationService.confirm({
      message: `This will send actual email do you want to continue?`,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.nowLoadingModal = true;
        this.service.sendEmail(this.selectedItem?.id ?? 0).subscribe(() => {
          this.refreshData();
          this.selectedItem = null;
          this.displayEmailPreview = false;
        });
      }
    });
  }

  downloadFile(attachment: any) {
    const url = window.URL.createObjectURL(this.base64ToBlob(attachment.content, attachment.contentType));
    const a = document.createElement('a');
    a.href = url;
    a.download = attachment.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  private base64ToBlob(base64: string, mimeType: string) {
    // Decode base64 string
    const byteCharacters = atob(base64);

    // Convert to byte array
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Create Blob
    return new Blob([byteArray], { type: mimeType });
  }
}
